import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Plan, Feature, FeatureMap, FeatureAvailability } from '../../models/catalog.model';

@Component({
  selector: 'plan-options',
  template: require('./plan-options.component.html'),
  styles: [require('./plan-options.component.scss')]
})
export class PlanOptionsComponent {
  @Input() public plans: Plan[];
  @Output() public selectionEvent = new EventEmitter();

  public selectedPlan(plan: Plan): void {
      this.selectionEvent.emit(plan);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/plans/plan-options.component.ts